import { render, staticRenderFns } from "./IconWithLabel.vue?vue&type=template&id=78ec9ae2&scoped=true&"
import script from "./IconWithLabel.vue?vue&type=script&lang=js&"
export * from "./IconWithLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec9ae2",
  null
  
)

export default component.exports